import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { ActivatedRoute } from '@angular/router';
import { PackageService } from '@services/packages/package.service';
import {EnvironmentService} from "@services/environment/environment.service";

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss', './ibexsmart.scss'],
  providers: [PackageService],
  standalone: false
})

export class PreviewComponent implements OnDestroy, OnInit {
  availablePlayouts = { ibextouch: 'ibexTouch', ibextablet: 'ibexTablet', ibexsmart: 'ibexApp' };
  tabletTypes: {}
  projects = [];
  selectedProject: any;
  content;
  textOnly = true;
  package;
  loading = false;
  scale = 1;
  widgetBorderRadius = '20px';
  disableBlurInApp = false;
  private linkElement: HTMLLinkElement;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PreviewComponent>, private translate: TranslateService, private route: ActivatedRoute,
    private packageService: PackageService, private renderer: Renderer2, private environmentService: EnvironmentService
  ) {
    window['forcePackage'] = this.route.snapshot.queryParams['packageId'] || window['forcePackage'];
    this.dialogRef.beforeClosed().subscribe(() => {
      window['forcePackage'] = null;
    });
    this.translate.get('preview');
  }

  async ngOnInit() {
    await this.init();
    if (this.data) {
      if (this.data?.documents) {
        let assetPath = this.environmentService.getFileAssetPath();
        this.data.documents = this.data.documents.map(doc => {
          doc.url = assetPath + doc.url;
          return doc;
        });
      }
      this.content = this.data;
      console.log(this.content);
      this.textOnly = ((!!this.content.media && !!this.content.media.length) && !(this.content.latitude && this.content.longitude));
    }
    this.renderer.listen('window', 'resize', () => {
      this.scalePreview();
    });
  }

  async init() {
    this.package = await this.packageService.get(window['forcePackage']);
    if (this.package) {
      this.disableBlurInApp = this.package?.ibexTouch?.disableBlurInApp;
      this.widgetBorderRadius = this.package.ibexTouch?.cardCorners ? this.package.ibexTouch?.cardCorners + (this.package.ibexTouch?.cardCorners.indexOf('px') > -1 ? '' : 'px') : this.widgetBorderRadius;
      this.projects = Object.keys(this.availablePlayouts).filter(type => {
        return !!(this.package?.devices?.length ? this.package?.devices?.includes(type) : !!this.package?.[this.availablePlayouts[type]]?.enabled);
      });
      this.selectProject(this.projects[0]);
    } else {
      this.loading = false;
    }
    const css = !!this.package?.linkName && this.loadCss();
  }

  loadCss() {
    this.linkElement = document.createElement('link');
    this.linkElement.rel = 'stylesheet';
    this.linkElement.href = `https://smartbeta.ibexfusion.com/${this.package.linkName}/customCss.css`;
    document.head.appendChild(this.linkElement);
  }

  async selectProject(project) {
    this.scale = 1;
    this.selectedProject = project;
    this.loading = true;
    while (!document.querySelectorAll('.preview-container')?.length) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    let bgUrl = this.selectedProject === 'ibexsmart' ? '' : this.getSeasonImage(this.package.screen.screenImages);
    if (!bgUrl || bgUrl === '') {
      bgUrl = '../assets/img/login.jpg'
    }
    document.querySelectorAll('.preview-container').forEach(el => {
      (el as any).style.backgroundImage = 'url("' + bgUrl + '")';
    });
    if (this.selectedProject === 'ibexsmart' && this.package?.ibexApp?.primary) {
      while (!document.querySelector('.ibexsmart')) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      const element: any = document.querySelector('.ibexsmart');
      element.style.setProperty('--ion-color-primary', this.package.ibexApp.primary);
      if (this.package.ibexApp.primaryShade) {
        element.style.setProperty('--ion-color-primary-shade', this.package.ibexApp.primaryShade);
      }
      if (this.package.ibexApp.primaryTint) {
        element.style.setProperty('--ion-color-primary-tint', this.package.ibexApp.primaryTint);
      }
    }
    this.scalePreview();
  }

  scalePreview() {
    if (this.content?.contentType === 'ticker') {
      return this.loading = false;
    }
    const previewContainer = document.querySelector('.preview-container');
    const sizes = { ibextouch: { height: 793, width: 1370 }, ibexsmart: { height: 852, width: 430 }, ibextablet: { height: 694, width: 770 } }
    if (previewContainer) {
      const previewContainerHeight = previewContainer.clientHeight;
      const previewContainerWidth = previewContainer.clientWidth;
      const heightRatio = (previewContainerHeight - 40) / sizes[this.selectedProject].height;
      const widthRatio = (previewContainerWidth - 40) / sizes[this.selectedProject].width;
      if (heightRatio < 1 || widthRatio < 1) {
        this.scale = heightRatio < widthRatio ? Math.round(heightRatio * 10) / 10 : Math.round(widthRatio * 10) / 10
      }
    }
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  public getSeasonImage(images) {
    if (!images[0]?.url && !images[0]?.imagePath && !images[0]?.urlHome) {
      return '';
    }

    let imageUrl = images[0].url || images[0].imagePath || images[0]?.urlHome;
    const now = { m: new Date().getMonth(), d: new Date().getDate() };

    const active = images.map((image, index) => {
      if (image.disabled) {
        return null;
      }

      const from = image.from ? { m: image.from.getMonth(), d: image.from.getDate() } : { m: 0, d: 1 };
      const to = image.to ? { m: image.to.getMonth(), d: image.to.getDate() } : { m: 11, d: 31 };
      const dateFrom = new Date(from.m, from.d);
      const dateTo = new Date(to.m, to.d);
      if (from.m > to.m) {
        dateTo.setFullYear(dateTo.getFullYear() + 1);
      }

      const fromBeforeTo = from.m < to.m || (from.m === to.m && from.d <= to.d);
      const fromBeforeNow = from.m < now.m || (from.m === now.m && from.d <= now.d);
      const toAfterNow = to.m > now.m || (to.m === now.m && to.d >= now.d);

      if ((fromBeforeTo && fromBeforeNow && toAfterNow) || (!fromBeforeTo && fromBeforeNow && toAfterNow)) {
        return { index, differenceInTime: dateTo.getTime() - dateFrom.getTime() };
      }
      return null;
    }).filter(Boolean).sort((a, b) => a.differenceInTime - b.differenceInTime);

    if (active.length) {
      const activeSeasonImage = active[0].index;
      imageUrl = images[activeSeasonImage].url || images[activeSeasonImage].imagePath || images[activeSeasonImage].urlHome;
    }

    return imageUrl;
  }

  ngOnDestroy() {
    if (this.linkElement) {
      document.head.removeChild(this.linkElement);
      this.linkElement = null;
    }
  }

  isOverflowing(): boolean {
    if (!document.getElementById('message') || this.selectedProject !== 'ibextouch') {
      return false;
    }
    const textHeight = document.getElementById('message').getElementsByClassName('text')[0].scrollHeight
    const imageHeight = document.getElementById('message').getElementsByClassName('content-image')?.[0]?.scrollHeight || 0;
    return textHeight + imageHeight > document.getElementById('message').getElementsByClassName('content-container')[0].clientHeight;
  }
}
